import React, { useState, forwardRef, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import moment from 'moment';
// import InputMask from 'react-input-mask';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import Alert from 'react-s-alert';

// import polygonIcon from '../../../assets/img/polygon.png'

const formatDate = (date, def = '', format = 'YYYY-MM-DD') => {
  try {
    const endDate = moment(date, 'YYYY-MM-DD HH:mm').format(format);

    if (_.isEmpty(date) && date === '') {
      return endDate === '';
    }

    if (endDate === 'Invalid date') {
      Alert.warning('Entered date is invalid');
    }

    const newDate = endDate === 'Invalid date' ? '' : endDate;

    return newDate;
  } catch (error) {
    return def;
  }
};

const CustomRender = forwardRef(({ onClick }, ref) => (
  <button
    type="button"
    ref={ref}
    className="btn btn-secondary btn-sm"
    onClick={onClick}
  >
    <i className="fa fa-lg fa-calendar" />
  </button>
));

CustomRender.propTypes = {
  onClick: PropTypes.instanceOf(Function),
};

CustomRender.defaultProps = {
  onClick: () => {},
};

const renderDateFormat = (showMonthYearPicker, withTime) => {
  if (showMonthYearPicker) {
    return 'YYYY-MM';
  }
  if (withTime) {
    return 'YYYY-MM-DD HH:mm';
  }
  return 'YYYY-MM-DD';
};

const renderPlaceHolder = (data, showMonthYearPicker, withTime) => {
  let placeHolder = '';
  if (data.length > 0) {
    return data;
  }

  placeHolder = () => {
    if (showMonthYearPicker) {
      return 'YYYY-MM';
    }
    if (withTime) {
      return 'YYYY-MM-DD HH:MM';
    }
    return 'YYYY-MM-DD';
  };

  return placeHolder();
};

function DateInputPicker4({
  // disabled,
  withTime,
  // isRequired,
  // placeholder,
  onChange,
  maxDate,
  minDate,
  value,
  openToDate,
  dateFormat,
  showYearPicker,
  showMonthYearPicker,
  otherProps,
}) {
  const [selected, setSelected] = useState(null);

  const handleChangePicker = (e) => {
    const newVal = formatDate(
      e,
      '',
      renderDateFormat(showMonthYearPicker, withTime)
    );
    onChange({ target: { value: newVal } });
  };

  useEffect(() => {
    setSelected(value);
  }, [value]);

  return (
    <div className="input-group">
      <div className="input-group-btn ">
        <DatePicker
          wrapperClassName="date-picker-wrapper"
          selected={new Date(value || openToDate)}
          // selected={value || new Date()}
          showMonthYearPicker={showMonthYearPicker}
          onChange={handleChangePicker}
          showTimeSelect={withTime}
          timeIntervals={15}
          openToDate={!_.isEmpty(value) ? new Date(selected) : openToDate}
          dateFormat={dateFormat}
          timeFormat="HH:mm"
          maxDate={maxDate}
          minDate={minDate}
          placeholder={renderPlaceHolder}
          showYearPicker={showYearPicker}
          {...otherProps}
        />
      </div>
    </div>
  );
}

DateInputPicker4.defaultProps = {
  // disabled: false,
  showMonthYearPicker: false,
  withTime: false,
  // isRequired: false,
  // placeholder: '',
  maxDate: new Date('3000-01-01'),
  minDate: new Date('1900-01-01'),
  openToDate: new Date(),
  value: '',
  otherProps: '',
};

/* eslint-disable */
DateInputPicker4.propTypes = {
  // disabled: PropTypes.bool,
  showMonthYearPicker: PropTypes.bool,
  withTime: PropTypes.bool,
  // isRequired: PropTypes.bool,
  // placeholder: PropTypes.string,
  onChange: PropTypes.instanceOf(Function).isRequired,
  maxDate: PropTypes.instanceOf(Date),
  minDate: PropTypes.instanceOf(Date),
  dateFormat: PropTypes.string.isRequired,
  openToDate: PropTypes.instanceOf(Date),
  showYearPicker: PropTypes.bool,
  value: PropTypes.string,
  otherProps: PropTypes.node,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([withRouter, connect(mapStateToProps)]);

export default enhance(DateInputPicker4);